export default {
  name: "HierarchicalMenuList",
  props: {
    items: {
      type: Array,
      required: !0
    },
    level: {
      type: Number,
      required: !0
    },
    refine: {
      type: Function,
      required: !0
    },
    createURL: {
      type: Function,
      required: !0
    },
    suit: {
      type: Function,
      required: !0
    }
  }
};